import {
    Box,
    Divider,
    FormControl,

    Grid,

    MenuItem,

    TextField,
    Typography
} from "@material-ui/core";
import {ArrowForward, ArrowRight, CheckCircleOutline, Search, SignalCellularNullRounded} from "@material-ui/icons";
import {Autocomplete} from "@material-ui/lab";
import {makeStyles} from '@material-ui/core/styles';
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    getBatchCountByWarehouse, getStatesInBatch,

    transferPackagesByWarehouseOrState,

} from "../../../actions/workflowAction";
import {showAlertSnackbar} from "../../../reducers/uiSlice";
import {getUserPreference} from "../../../utilities/common";
import {green} from "@material-ui/core/colors";
import _ from "lodash";
import {useAlert} from "../../../utilities/hooks";
import {alertType} from "../../Common/UniAlert/context";
import {useTranslation} from "react-i18next";
import FullscreenLoading from "../../Common/FullscreenLoading";
import SelectBatchBar from "../SelectBatchBar";
import TransferBar from "../TransferBar";

const useStyles = makeStyles((theme) => ({
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    verticalMargin: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    textSpace: {
        marginRight: theme.spacing(1)
    }
}))


export default function WorkFlow(props) {

    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const alertDialog = useAlert();
    const [subBatch, setSubBatch] = useState(null);
    const [subBatchTyped, setSubBathTyped] = useState("");
    const [warehouse, setWarehouse] = useState(-1);
    const [stateToTransfer, setStateToTransfer] = useState(0);
    const [uiAssignModeRadio, setUiAssignModeRadio] = useState("1"); //MUST BE A STRING 0 = manual, 1 = auto
    const [manualBatchNumber, setManualBatchNumber] = useState("");
    const [states, setStates] = useState([])
    const [stateError, setStateError] = useState("");
    const [warehouses, setWarehouses] = useState([]);
    const [warehouseLoading, setWarehouseLoading] = useState(false);
    const [fullscreenLoading, setFullscreenLoading] = useState(false);
    const [stateLoading, setStateLoading] = useState(false);
    const [ableToTransfer, setAbleToTransfer] = useState(false);

    const handleAbleTransit = (ableTransit) => {
        setAbleToTransfer(ableTransit);
    }
    const handleuiAssignModeRadio = (uiAssignModeRadio) => {
        setUiAssignModeRadio(uiAssignModeRadio);
    }
    const handleManualBatchNumber = (manualBatchNumber) => {
        setManualBatchNumber(manualBatchNumber);
    }
    const handleSubBatch = (subBatch) => {
        setSubBatch(subBatch);
    }

    const handleSubBatchTyped = (subBatchTyped) => {
        setSubBathTyped(subBatchTyped);
    }

    const validBatchNumberRegex = /^[A-Z]+SUB-20\d{10}$/
    const validThirdPartBatchRegex = /^[A-Z]{3}-[A-Z]{2}-\d{8}$/

    useEffect(() => {
        if (subBatch !== null) {

            fetchBatchWarehouseCount(subBatch)
            fetchStatesFromBatch(subBatch)
        }
    }, [subBatch])


    useEffect(() => {
        if (ableToTransfer) {
            handleTransferOrders();
            setAbleToTransfer(false);
        }
    }, [ableToTransfer])


    const stepOneComplete = warehouses.length > 0 && stateError.length <= 0 && (subBatch !== null || subBatchTyped.length > 0)
    const stepTwoComplete = warehouse !== -1 && stepOneComplete


    return (
        <Box>
            {
                <FormControl component="fieldset" style={{marginBottom: 20}}>

                </FormControl>}
            <SelectBatchBar stepOneComplete={stepOneComplete}
                            handleSubBatch={handleSubBatch}
                            handleSubBatchTyped={handleSubBatchTyped}

            />
            <Divider/>

            {

                <div>
                    <div className={classes.verticalMargin}>
                        {states.length > 0 ?
                            <Grid container spacing={3}>
                                {states.map((state, index) => (
                                    <Grid key={`state-${index}`} item xs={3}>
                                        <div style={{display: 'flex', flexDirection: 'row'}}>
                                            <Typography className={classes.textSpace}>{state.pathInfo}: </Typography>
                                            <Typography>{state.qty}</Typography>
                                        </div>
                                    </Grid>
                                ))}
                            </Grid>
                            :
                            <Typography
                                style={{textAlign: 'center'}}>{stateError.length <= 0 ? "No Data To Display" : stateError}</Typography>
                        }
                    </div>
                    <Divider/>
                    <div className={`${classes.row} ${classes.verticalMargin}`}>
                        {stepOneComplete && !stepTwoComplete ?
                            <ArrowRight color='primary'/>
                            : stepTwoComplete ?
                                <CheckCircleOutline style={{color: green[500]}}/>
                                :
                                null}
                        <Typography className={classes.textSpace}>Step 2:</Typography>

                        {
                            <TextField
                                select
                                value={warehouse}
                                variant='outlined'
                                label='Select Warehouse'
                                style={{minWidth: 300}}
                                disabled={!stepOneComplete}
                                onChange={(event) => {
                                    setWarehouse(event.target.value)
                                }}
                            >
                                <MenuItem value={-1}>NONE</MenuItem>
                                {warehouses.map((warehouse, index) => (
                                    <MenuItem key={`warehouse-${index}`}
                                              value={warehouse.id}>{`${warehouse.name} (${warehouse.qty})`}</MenuItem>
                                ))}
                            </TextField>
                        }

                    </div>
                    <Divider/>
                    {
                        (states && states.length > 0) ?
                            <div>
                                <div className={`${classes.row} ${classes.verticalMargin}`} style={{}}>
                                    <TextField
                                        select
                                        value={stateToTransfer}
                                        variant='outlined'
                                        label='Package State'
                                        style={{minWidth: 300}}
                                        onChange={(event) => setStateToTransfer(event.target.value)}
                                    >
                                        <MenuItem value={0}>ALL</MenuItem>
                                        {states.map((state, index) => (
                                            <MenuItem key={`location-${index}`}
                                                      value={state.state}>{`${state.pathInfo} (${state.qty})`}</MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                                <Divider/>
                            </div>
                            :
                            null
                    }
                    <div>
                        <TransferBar stepOneComplete={stepOneComplete}
                                     stepTwoComplete={stepTwoComplete}
                                     handleAbleTransit={handleAbleTransit}
                                     handleuiAssignModeRadio={handleuiAssignModeRadio}
                                     handleManualBatchNumber={handleManualBatchNumber}
                        />
                    </div>
                </div>
            }
            <FullscreenLoading open={fullscreenLoading}/>
        </Box>
    )


    async function fetchBatchWarehouseCount(batchNo) {
        setWarehouseLoading(true)
        setWarehouse(-1)
        setWarehouses([])


        try {
            let result

            result = await dispatch(getBatchCountByWarehouse(batchNo))
            setWarehouses(result)


        } catch (error) {
            dispatch(showAlertSnackbar({title: `Cannot Load States For: ${batchNo}`}))
        }

        setWarehouseLoading(false)
    }

    function handleTransferOrders() {
        if (manualAssignBatchValidate()) {
            dispatch(showAlertSnackbar({title: "Please provide a batch number under manual mode!"}))
            return
        }
        if (warehouse !== -1) {
            alertDialog.addAlertDialog(
                "Transfer Orders",
                [
                    "Please confirm these information before transfer!",
                    `Batch Number: ${subBatch || subBatchTyped}`,
                    `To Warehouse: ${getWarehouseById(warehouse).name}`,
                    `State to Transfer: ${getSelectedStateByCode().pathInfo}`,
                    `Transfer Amount: ${getSelectedStateByCode().qty}`,
                    `Assign Mode: ${uiAssignModeRadio === "1" ? "AUTO" : "MANUAL"}`,
                    uiAssignModeRadio === "0" ? `Assign To: ${manualBatchNumber}` : null
                ],
                alertType.INFO,
                t('common:cancel')
            )
        }


        alertDialog.addActionButton(
            t('common:confirm'),
            () => {
                alertDialog.hideAlert()
                setFullscreenLoading(true)
                let params

                params = {
                    warehouse: warehouse,
                    original_batch: subBatch || subBatchTyped.trim(),
                    is_auto: Number(uiAssignModeRadio),
                    target_batch: manualBatchNumber.trim()
                }


                dispatch(
                    transferPackagesByWarehouseOrState(params)
                ).then((res) => {
                    setFullscreenLoading(false)
                    fetchBatchWarehouseCount(subBatch || subBatchTyped.trim())
                    alertDialog.addAlertDialog(
                        "Transfer Orders",
                        [
                            `Target Batch: ${res.target_batch}`,
                            `Total Transferred: ${res.total_transfered_tracking_info}`
                        ]
                    )
                    alertDialog.showAlert()
                }).catch(error => {
                    setFullscreenLoading(false)
                    alertDialog.addAlertDialog(
                        "Transfer Orders",
                        [
                            `Transfer failed! Reason below:`,
                            error.message
                        ]
                    )
                    alertDialog.showAlert()
                })
            },
            'primary'
        )
        alertDialog.showAlert()
    }

    function getSelectedStateByCode() {
        if (stateToTransfer === 0) {
            return {pathInfo: "ALL", qty: "ALL"}
        }
        return _.find(states, ['state', stateToTransfer])
    }

    function manualAssignBatchValidate() {
        if (uiAssignModeRadio === "0" && !validBatchNumberRegex.test(manualBatchNumber) && !validThirdPartBatchRegex.test(manualBatchNumber)) {
            return true
        }
        return false
    }

    function getWarehouseById(id) {

        return _.find(warehouses, ['id', id])

    }

    async function fetchStatesFromBatch(batchNo) {
        setStateError('')
        setStateLoading(true)
        setStates([])
        try {
            let result = await dispatch(getStatesInBatch(batchNo))
            setStates(result)
            if (result.length <= 0) {
                dispatch(showAlertSnackbar({title: `No States Found For: ${batchNo}`}))
            }
        } catch (error) {
            setStateError(`Cannot Load States For: ${batchNo}`)
            //dispatch(showAlertSnackbar({title: `Cannot Load States For: ${batchNo}`}))
        }
        setStateLoading(false)
    }
}